/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeARightIcon32Regular = forwardRef('ArrowShapeARightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.44 13.527a3.5 3.5 0 0 1 0 4.95L17.414 29.502c-1.26 1.26-3.415.367-3.415-1.415V23H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8V3.914c0-1.782 2.154-2.674 3.414-1.414L28.44 13.527Zm-1.415 3.535a1.5 1.5 0 0 0 0-2.121L16 3.915V10a1 1 0 0 1-1 1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9a1 1 0 0 1 1 1v6.088l11.026-11.025Z" })));
});
